(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(section) {
    if (section.dataset.ligInit === '1') return;
    section.dataset.ligInit = '1';

    var reveals = section.querySelectorAll('[data-lig-reveal]');
    var cards = section.querySelectorAll('[data-lig-card]');

    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
      cards.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
      cards.forEach(function (el) { io.observe(el); });
    }

    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (fine && !reduceMotion) {
      cards.forEach(function (card) {
        var media = card.querySelector('.lig-card__media');
        var glow = card.querySelector('.lig-card__glow');
        if (!media || !glow) return;

        var rafId = 0, px = 50, py = 50;
        function apply() {
          rafId = 0;
          glow.style.setProperty('--lig-mx', px + '%');
          glow.style.setProperty('--lig-my', py + '%');
        }
        card.addEventListener('pointermove', function (e) {
          var rect = media.getBoundingClientRect();
          px = ((e.clientX - rect.left) / rect.width) * 100;
          py = ((e.clientY - rect.top) / rect.height) * 100;
          if (!rafId) rafId = requestAnimationFrame(apply);
        }, { passive: true });
        card.addEventListener('pointerleave', function () {
          px = 50; py = 50;
          if (!rafId) rafId = requestAnimationFrame(apply);
        }, { passive: true });
      });
    }
  }

  function initAll(root) { (root || document).querySelectorAll('[data-lux-ig]').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
